export const queryKeys = {
  auth: { me: ['auth', 'me'] as const },
  employees: {
    list: (params: Record<string, unknown>) => ['employees', 'list', params] as const,
  },
  questions: {
    list: (params: Record<string, unknown>) => ['questions', 'list', params] as const,
    detail: (id: string) => ['questions', 'detail', id] as const,
  },
  rounds: {
    list: (params: Record<string, unknown>) => ['rounds', 'list', params] as const,
    detail: (id: string) => ['rounds', 'detail', id] as const,
    randomPreview: (id: string, params: unknown) =>
      ['rounds', 'random-preview', id, params] as const,
  },
  lobby: { openRounds: ['lobby', 'open-rounds'] as const },
  rpsRooms: {
    list: ['rps-rooms', 'list'] as const,
    detail: (id: string) => ['rps-rooms', 'detail', id] as const,
  },
  me: {
    history: (params?: Record<string, unknown>) => ['me', 'history', params ?? {}] as const,
    roundDetail: (roundId: string) => ['me', 'round-detail', roundId] as const,
  },
  leaderboard: {
    round: (roundId: string) => ['leaderboard', 'round', roundId] as const,
  },
} as const;
